<!--
  UIID: UI-Caas-MON-140
  UI Name: Biz File View (popup)
  Modify Date: 2021/02/01
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    class="dialog-drag-display monitor-bizfile-layout-dialog"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.monitoring.bizFileViewPop.page_header')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [S]  Popup body-->
    <v-card class="monitor-bizfile-layout-container">
      <v-card-text class="mb-2 pt-0">
        <v-row class="r-popup-content">
          <v-col cols="12" sm="12" class="grid-pd">
            <!-- <v-row v-show="Number($cookies.get('use-grade')) === 9" class="v-grid-title row-pd">
              <v-label>{{ $t('lbl.fileViewPop.targetDataPath') }}</v-label>
            </v-row>
            <v-row v-show="Number($cookies.get('use-grade')) === 9" class="v-grid-title row-pd">
              <v-input :hide-details="true">{{ this.outputBizFilePath }}</v-input>
            </v-row> -->
            <v-row class="v-grid-title row-pd pr-3">
              <v-col cols="12" sm="6" class="grid-pd pa-0 pt-1">
                <v-btn
                  small
                  class="btn btn-save-file mr-1"
                  @click.stop.prevent="
                    copyToClipboard();
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('lbl.fileViewPop.copyToClipboard') }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="grid-pd pa-0">
                <v-select
                  v-model="encodingOut"
                  dense
                  solo
                  :placeholder="$t('lbl.fileViewPop.selectCharSet')"
                  :items="encodings"
                  @change="doCharSet()"
                  class="custom-selectbox select-character-set"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="v-grid-content">
              <v-col class="pa-0">
                <v-row class="no-gutters">
                  <div class="CodeMirror">
                    <BIZViewer v-model="outputBizFileContents" :options="cmOption_out"></BIZViewer>
                    <input type="hidden" id="outputBizFileContentsHdn" />
                    <v-overlay :absolute="absolute" :value="overlayOut">
                      <v-btn color="success" @click="overlayOut = false">{{ this.outMsg }}</v-btn>
                    </v-overlay>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-delete" @click="removeDialog">{{ $t('btn.common.close') }}</v-btn>
            <v-btn
              class="btn btn-popup-search"
              color="primary"
              @click="downloadFileView(outputBizFileContents, outputBizFilePath)"
              :disabled="!$auth.manage"
              >{{ $t('btn.common.download') }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import { mapState } from 'vuex';
import IconSvg from '@/vue-caas/components/IconBase.vue';

// language
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

var encoding = require('encoding');

export default {
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    outputBizFileLink: String,
    fileViewInfo: Object,
  },
  components: {
    DialogDrag,
    BIZViewer,
    IconSvg,
  },
  name: 'monitoring-file-view-window',

  data: () => ({
    absolute: true,
    overlayOut: false,
    outputBizFilePath: '',
    outputBizFileContents: '',
    outputBizFileContentsHdn: '',
    encodingOut: '',
    encodings: [
      { text: 'Character Set', value: '' },
      { text: 'UTF-8', value: 'UTF-8' },
      { text: 'ASCII', value: 'ASCII' },
      { text: 'ISO-8859-1', value: 'ISO-8859-1' },
      { text: 'ISO-8859-15', value: 'ISO-8859-15' },
      { text: 'EUC-KR', value: 'EUC-KR' },
      { text: 'EUC-JP', value: 'EUC-JP' },
      { text: 'GB2312', value: 'GB2312' },
      { text: 'UTF-16LE', value: 'UTF-16LE' },
      { text: 'BASE64', value: 'BASE64' },
    ],
    inMsg: '',
    outMsg: '',
  }),
  computed: {
    cmOption_in() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: this.readonlyModeStatus,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: this.readonlyModeStatus,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    cmOption_out() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
  },
  methods: {
    initialize() {
      this.outputBizFilePath = this.outputBizFileLink;

      this.$store.dispatch('getoutputBizFileContens', this.outputBizFileLink).then(() => {
        if (this.$store.getters.outputBizFileContents != null) {
          this.outputBizFileContents = this.$store.getters.outputBizFileContents
            .split(`'`)
            .join('\n');
          this.outputBizFileContentsHdn = this.$store.getters.outputBizFileContents
            .split(`'`)
            .join('\n');
        }
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    downloadFileView(content, title) {
      var data = new Blob([content], { type: 'text/plain' });
      var url = window.URL.createObjectURL(data);
      let edifileArr = title.split('/');
      var a = document.createElement('a');
      a.href = url;
      a.download = edifileArr[edifileArr.length - 1];
      document.body.appendChild(a);
      a.click();
    },

    doCharSet() {
      if (this.encodingOut !== undefined && this.encodingOut !== '') {
        var result = encoding.convert(this.outputBizFileContentsHdn, this.encodingOut);
        this.outputBizFileContents = result.toString();
      }
    },
    copyToClipboard() {
      let constents = this.outputBizFileContents;

      if (window.clipboardData !== undefined) {
        window.clipboardData.setData('text', constents);
      } else {
        var t = document.createElement('textarea');
        document.body.appendChild(t);
        t.value = constents;
        t.select();
        document.execCommand('copy');
        document.body.removeChild(t);
      }
      this.outMsg = 'Copied !!!';
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style>
/* .monitor-bizfile-layout-dialog{
  width: 700px !important;
}
.monitor-bizfile-layout-dialog .v.grid-content{
  height: 528px;
  margin-bottom:10px !important;
} */
.monitor-bizfile-layout-container .CodeMirror-gutters {
  left: 0 !important;
}
.monitor-bizfile-layout-container .CodeMirror-gutter-wrapper {
  left: -36px !important;
}
.monitor-bizfile-layout-container .v-grid-title .v-input {
  height: auto !important;
}
.monitor-bizfile-layout-container .v-grid-title .v-input .v-input__slot {
  height: 40px !important;
}
.theme--light .monitor-bizfile-layout-container .v-grid-title .v-input {
  background: #ffffff;
}
.theme--dark .monitor-bizfile-layout-container {
  background-color: #3b3e49 !important;
}
.theme--dark .monitor-bizfile-layout-container .v-grid-content {
  height: 528px;
  background-color: #2a2c35;
}
.theme--dark .monitor-bizfile-layout-container .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
}
/* .dialogs .dialog-drag .dialog-body {
    padding-top: 30px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    padding-bottom: 30px !important;
} */

.v-select {
  padding: 0 !important;
  /* 2021.01.14 - 202728 - issue common 39 */
  /* background:#2a2c35 !important; */
}
</style>
